import React from 'react';
import {Props} from './Props';
import MessageAgeInMinutes from '../../../../../../components/MessageAgeInMinutes';
import {convertWazeTypeAndSubtypeToTranslatedEventType} from '../../../../../../services/Utilities';
import TimeFormatted from '../../../../../../components/TimeFormatted';

const DialogWazeAlertOther: React.FunctionComponent<Props> = ({currentProperties, showRecordIds}) => {
    return (
        <table>
            <tbody>
                {showRecordIds && (
                    <tr>
                        <th>ID</th>
                        <td>{currentProperties.id}</td>
                    </tr>
                )}
                <tr>
                    <th>Type</th>
                    <td>
                        {convertWazeTypeAndSubtypeToTranslatedEventType(
                            currentProperties.type,
                            currentProperties.subType,
                        )}
                    </td>
                </tr>
                <tr>
                    <th>Starttijd</th>
                    <td>
                        <TimeFormatted dateTime={currentProperties.startedAt} />
                    </td>
                </tr>
                <tr>
                    <th>Duur incident</th>
                    <td>
                        <MessageAgeInMinutes time={currentProperties.startedAt} />
                    </td>
                </tr>
                <tr>
                    <th>Locatie</th>
                    <td>
                        {currentProperties.address} {currentProperties.city}
                    </td>
                </tr>
                <tr>
                    <th>Bevestigingen</th>
                    <td>{currentProperties.confirmedCount || 0}</td>
                </tr>
                <tr>
                    <th>Laatste bevestiging</th>
                    <td>
                        <MessageAgeInMinutes time={currentProperties.startedAt} />
                    </td>
                </tr>
                <tr>
                    <th>Betrouwbaarheid melder</th>
                    <td>{currentProperties.rating}</td>
                </tr>
            </tbody>
        </table>
    );
};

export default DialogWazeAlertOther;
